import request from '../helpers/request'
import axios from 'axios'
import { URLSearchParams } from 'core-js/modules/web.url-search-params'

const DEFAULT_ENDPOINTS = {
  phoneUrl: '/phone-verification/',
  checkCodeUrl: '/check-code/',
  registerWithEmail: '/email-verification/',
  loginWithEmail: '/login-via-password/',
  changePassword: '/cabinet/profile/change-password/',
  recoveryPassword: '/password-recovery/',
  restorePassword: '/password-restore/',
  verifyEmail: '/verify-by-email/',
  sendVerifyCode: '/send-verify-code/',
  sendOneTimePass: '/verify-code-received-by-email/',
  setPassword: '/set-password/',
  checkPhone: '/auth/auth/check-phone/'
}

export default {
  checkPhone: async ({ phone }) => {
    const endpoint = DEFAULT_ENDPOINTS.checkPhone
    const { data } = await request.post(endpoint, { phone })
    return data
  },
  registerGuest: async ({ name, lastName, phone, email, gaClientId, gaSessionId }) => {
    const endpoint = '/shop/checkout/register-guest/'
    const { data } = await request.post(endpoint, {
      name,
      last_name: lastName,
      phone,
      email,
      AnalyticsForm: {
        ga_client_id: gaClientId,
        ga_session_id: gaSessionId
      }
    })
    if (data.csrf) {
      document.head.querySelector('meta[name="csrf-token"]').content = data.csrf
      axios.defaults.headers.common['x-csrf-token'] = data.csrf
      request.defaults.headers.common['x-csrf-token'] = data.csrf
    }
    return data
  },
  setPassword: async ({ remember, email, isGeneratePassword, password, confirmPassword }) => {
    const endpoint = DEFAULT_ENDPOINTS.setPassword
    const { data } = await request.post(endpoint, { remember, email, isGeneratePassword, password, confirmPassword })
    return data
  },
  loginWithEmail: async ({ email, password, remember }) => {
    const endpoint = DEFAULT_ENDPOINTS.loginWithEmail
    const { data } = await request.post(endpoint, { UserLoginForm: { email, password, remember } })
    return data
  },
  sendOneTimePass: async ({ email, code, remember }) => {
    const endpoint = DEFAULT_ENDPOINTS.sendOneTimePass
    const { data } = await request.post(endpoint, { email, code, remember })
    return data
  },
  changePassword: async ({ password, newPassword, confirmNewPassword }) => {
    const endpoint = DEFAULT_ENDPOINTS.changePassword
    const { data } = await request.post(endpoint, { ChangePasswordForm: { password, newPassword, confirmNewPassword } })
    return data
  },
  restorePassword: async ({ password, confirmPassword }) => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const endpoint = DEFAULT_ENDPOINTS.restorePassword + '?token=' + token
    const { data } = await request.post(endpoint, { RestorePasswordForm: { password, confirmPassword } })
    return data
  },
  recoveryPassword: async ({ email }) => {
    const endpoint = DEFAULT_ENDPOINTS.recoveryPassword
    const { data } = await request.post(endpoint, { email })
    return data
  },
  registerWithEmail: async ({ email }) => {
    const endpoint = DEFAULT_ENDPOINTS.registerWithEmail
    const { data } = await request.post(endpoint, { email })
    return data
  },
  verifyPhone: async ({ phone, url }) => {
    const endpoint = url || DEFAULT_ENDPOINTS.phoneUrl
    const { data } = await request.post(endpoint, { phone })
    return data
  },
  verifyEmail: async ({ email, remember }) => {
    const endpoint = DEFAULT_ENDPOINTS.verifyEmail
    const { data } = await request.post(endpoint, { email, remember })
    return data
  },
  verifyCode: async ({ phone, code, url, remember }) => {
    const endpoint = url || DEFAULT_ENDPOINTS.checkCodeUrl
    const { data } = await request.post(endpoint, { phone, code, remember })
    return data
  },
  sendVerifyCode: async ({ email, isResend }) => {
    const endpoint = DEFAULT_ENDPOINTS.sendVerifyCode
    const { data } = await request.post(endpoint, { email, send_again: isResend })
    return data
  }
}
